import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeTitleBanner, getPermissions } from '../../store/actions';
import { getRouteNameFromURL } from '../../helpers/routing_helper';

export default (pathname: string) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPermissions({ sizePerPage: 100, page: 1 }));
    }, []);

    const [pageTitle, setPageTitle] = useState('');
    const { permissions } = useSelector((state: any) => state.Permissions);

    useEffect(() => {
        const name = getRouteNameFromURL(pathname, permissions);

        setPageTitle(name);
    }, [permissions, pathname]);

    useEffect(() => {
        dispatch(changeTitleBanner(pageTitle.replace(/-/g, ' ')))
    },[pageTitle]);

    return pageTitle;
};
